import { useMutation, useQueryClient } from "@tanstack/react-query"
import { appointment } from '@shared/api/services';

export const useAddHomeworkSubmission = (appointmentId, onSuccess = () => {}) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: appointment.submitHomework,
    onSuccess: () => {
      queryClient.invalidateQueries(['appointment', appointmentId])
			onSuccess()
    },
  })

	return mutation
}